import CopyItem from './CopyItem';

export default CopyItem;
